import React, { PureComponent } from 'react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

class PopoverBottom extends PureComponent {
  static propTypes = {
    targetId: PropTypes.string.isRequired,
    title: PropTypes.string,
    children: PropTypes.element,
    placement: PropTypes.oneOf([
      'auto',
      'auto-start',
      'auto-end',
      'top',
      'top-start',
      'top-end',
      'right',
      'right-start',
      'right-end',
      'bottom',
      'bottom-start',
      'bottom-end',
      'left',
      'left-start',
      'left-end',
    ]),
  };

  static defaultProps = {
    title: '',
    children: null,
    placement: 'bottom',
  };

  constructor() {
    super();
    this.state = {
      popoverOpen: false,
    };
  }

  toggle = () => {
    this.setState((prevState) => ({ popoverOpen: !prevState.popoverOpen }));
  };

  render() {
    const { targetId, children, title, placement } = this.props;
    const { popoverOpen } = this.state;

    return (
      <Popover
        placement={placement}
        isOpen={popoverOpen}
        target={targetId}
        toggle={this.toggle}
        className="smart-popover"
      >
        {title ? <PopoverHeader>{title}</PopoverHeader> : null}
        <PopoverBody>{children}</PopoverBody>
      </Popover>
    );
  }
}

export default withTranslation('common')(PopoverBottom);
